module.exports = vendor_library;


//////////////////
// WEBPACK FOOTER
// external "vendor_library"
// module id = 15
// module chunks = 0